import matestackEventHub from '../event_hub';
import componentMixin from './mixin';
import componentHelpers from './helpers';
var componentDef = {
  mixins: [componentMixin],
  template: componentHelpers.inlineTemplate,
  props: {
    initialTemplate: String
  },
  data: function data() {
    return {
      cableTemplate: null,
      cableTemplateDomElement: null,
      loading: false,
      event: {
        data: {}
      }
    };
  },
  methods: {
    append: function append(payload) {
      var html = this.formatPayload(payload);
      this.cableTemplateDomElement.insertAdjacentHTML('beforeend', html.join(''));
      this.updateCableTemplate();
    },
    prepend: function prepend(payload) {
      var html = this.formatPayload(payload);
      this.cableTemplateDomElement.insertAdjacentHTML('afterbegin', html.join(''));
      this.updateCableTemplate();
    },
    "delete": function _delete(payload) {
      var _this = this;

      var ids = this.formatPayload(payload);
      ids.forEach(function (id) {
        return _this.cableTemplateDomElement.querySelector('#' + id).remove();
      });
      this.updateCableTemplate();
    },
    update: function update(payload) {
      var self = this;
      var html = this.formatPayload(payload);
      html.forEach(function (elem) {
        var dom_elem = document.createElement('div');
        dom_elem.innerHTML = elem.replace(/^\s+|\s+$/g, '');
        var id = dom_elem.firstChild.id;
        var old_elem = self.cableTemplateDomElement.querySelector('#' + id);
        old_elem.parentNode.replaceChild(dom_elem.firstChild, old_elem);
      });
      this.updateCableTemplate();
    },
    replace: function replace(payload) {
      var html = this.formatPayload(payload);
      this.cableTemplateDomElement.innerHTML = html.join('');
      this.updateCableTemplate();
    },
    updateCableTemplate: function updateCableTemplate() {
      this.cableTemplate = this.cableTemplateDomElement.outerHTML;
    },
    formatPayload: function formatPayload(payload) {
      if (!Array.isArray(payload.data)) {
        return [payload.data];
      }

      return payload.data;
    }
  },
  mounted: function mounted() {
    var self = this;
    var dom_elem = document.createElement('div');
    dom_elem.innerHTML = this.initialTemplate;
    this.cableTemplateDomElement = dom_elem.querySelector("#" + this.props["id"]);
    this.cableTemplate = this.cableTemplateDomElement.outerHTML;
    this.registerEvents(this.props['append_on'], self.append);
    this.registerEvents(this.props['prepend_on'], self.prepend);
    this.registerEvents(this.props['delete_on'], self["delete"]);
    this.registerEvents(this.props['update_on'], self.update);
    this.registerEvents(this.props['replace_on'], self.replace);
  },
  beforeUnmount: function beforeUnmount() {
    var self = this;
    this.cableTemplate = null;
    this.removeEvents(this.props['append_on'], self.append);
    this.removeEvents(this.props['prepend_on'], self.prepend);
    this.removeEvents(this.props['delete_on'], self["delete"]);
    this.removeEvents(this.props['update_on'], self.update);
    this.removeEvents(this.props['replace_on'], self.replace);
  }
};
export default componentDef;